<template>
  <v-container>
    <!-- Sticky inventory availability notice -->
    <div
      class="inventory-availability-banner"
      role="note"
      aria-label="Inventory availability notice"
    >
      <div>
        THIS SYSTEM IS NOT A LIVE BOOKING SYSTEM. DISPLAY OF DATES DOES NOT
        GUARANTEE AVAILABILITY
      </div>
      <div>DATES WILL BE DISPLAYED 30-180 DAYS FROM TODAY EACH DAY</div>
    </div>

    <!-- toolbar -->

    <v-row>
      <v-col cols="12">
        <v-toolbar dense color="primary" dark flat rounded>
          <v-toolbar-title>Browse Travel Accommodations</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- back btn -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                depressed
                dark
                v-bind="attrs"
                v-on="on"
                @click="$router.go(-1)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>

            <span>Back</span>
          </v-tooltip>

          <!-- back btn -->

          <!-- home/dashboard btn -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                depressed
                dark
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/dashboard')"
              >
                <v-icon>mdi-home-outline</v-icon>
              </v-btn>
            </template>

            <span>Home</span>
          </v-tooltip>

          <!-- home/dashboard btn -->

          <!-- dark mode button -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                depressed
                dark
                v-bind="attrs"
                v-on="on"
                @click="$vuetify.theme.dark = !$vuetify.theme.dark"
              >
                <v-icon>{{
                  $vuetify.theme.dark
                    ? "mdi-lightbulb-outline"
                    : "mdi-lightbulb"
                }}</v-icon>
              </v-btn>
            </template>

            <span>Dark Mode</span>
          </v-tooltip>

          <!-- dark mode button -->

          <!-- sign out btn -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                depressed
                dark
                v-bind="attrs"
                v-on="on"
                @click="onSignOut"
                class="d-none d-sm-inline-flex"
              >
                <v-icon>mdi-logout-variant</v-icon>
              </v-btn>
            </template>

            <span>Sign Out</span>
          </v-tooltip>

          <!-- sign out btn -->

          <!-- notifications button -->

          <!-- <v-menu

            left

            bottom

            offset-y

            transition="slide-y-transition"

            v-if="userAccount.newDashboardMessageNotification"

          >

            <template v-slot:activator="{ on, attrs }">

              <v-btn

                dark

                depressed

                color="primary"

                v-bind="attrs"

                v-on="on"

                class="d-none d-sm-inline-flex"

              >

                <v-badge color="pink">

                  <v-icon>mdi-bell</v-icon>

                </v-badge>

              </v-btn>

            </template>



            <v-list dense :class="$vuetify.theme.dark ? '' : 'grey lighten-3'">

              <v-list-item

                :class="$vuetify.theme.dark ? '' : 'grey lighten-3'"

                link

                @click="$router.push('/dashboard')"

                v-if="userAccount.newDashboardMessageNotification"

              >

                <v-list-item-title

                  >You have a new message. Click here to review your

                  timeline.</v-list-item-title

                >

              </v-list-item>

            </v-list>

          </v-menu> -->

          <!-- notifications button -->
        </v-toolbar>
      </v-col>
    </v-row>

    <!-- toolbar -->

    <!-- items table -->

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="text--primary">
            <v-row>
              <v-col
                cols="12"
                md="8"
                class="text-subtitle-1 font-weight-medium"
              >
                Accommodations for

                <span class="text-capitalize">{{ altDestination.name }}</span>
              </v-col>

              <v-col cols="12" md="4" align="end">
                {{ items.length }} Options Available
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text class="text--primary pt-0">
            <!-- Sort controls -->

            <v-row dense align="center" class="mb-2">
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-select
                  v-model="sortBy"
                  :items="sortOptions"
                  label="Sort by"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-btn
                  outlined
                  dense
                  class="mt-sm-0"
                  @click="sortDesc = !sortDesc"
                >
                  <v-icon left>
                    {{
                      sortDesc ? "mdi-sort-descending" : "mdi-sort-ascending"
                    }}
                  </v-icon>

                  {{ sortDesc ? "Descending" : "Ascending" }}
                </v-btn>
              </v-col>
            </v-row>

            <v-data-table
              dense
              :items="items"
              :items-per-page="-1"
              :headers="headers"
              fixed-header
              :height="650"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @click:row="onViewAccommodation"
            >
              <template v-slot:[`item.moreInfo`]="{ item }">
                <v-btn small text color="primary">Book/More Info</v-btn>

                {{ item.moreInfo }}
              </template>

              <template v-slot:[`item.checkInDate`]="{ item }">
                {{ formatDate(item.checkInDate) }}
              </template>

              <template v-slot:[`item.checkOutDate`]="{ item }">
                {{ formatDate(item.checkOutDate) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- items table -->
  </v-container>
</template>

<script>
import firebase from "@/plugins/firebase";

import Moment from "moment";

import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

import formatDate from "@/mixins/formatDate";

import onSignOut from "@/mixins/onSignOut";

const userAccounts = firebase.firestore().collection("userAccounts");

export default {
  mixins: [formatDate, onSignOut],

  async mounted() {
    if (!this.userID) return this.$router.push("/");

    await this.$store.dispatch("setLoading", true);

    // bind userAccount

    let userAccount = await this.$bind(
      "userAccount",

      userAccounts.doc(this.userID),
    );

    // route guards

    if (
      !userAccount.canBook ||
      !userAccount.canAccess ||
      !userAccount.canBrowseInventory
    )
      return this.$router.push("/dashboard");

    // get eventReport

    let eventReport = await firebase

      .firestore()

      .collection("eventReports")

      .doc(userAccount.eventReportID)

      .get();

    eventReport = eventReport.data();

    this.eventReport = eventReport;

    // get specificWinner in eventReport winners array

    let specificWinner = eventReport.winners.filter(
      (i) => i.packageID == userAccount.packageID,
    )[0];

    this.specificWinner = specificWinner;

    // get specificWinner retail package to list inventory options

    let retailPackage = firebase

      .firestore()

      .collection("retailPackages")

      .doc(specificWinner.packageCode);

    retailPackage = await retailPackage.get();

    retailPackage = retailPackage.data();

    this.winnerRetailPackage = retailPackage;

    // get alternative destination inventory ids

    let resortPropertyIds = await firebase

      .firestore()

      .collection("alternativeDestinations")

      .doc(this.$route.params.id)

      .get();

    resortPropertyIds = resortPropertyIds.data();

    resortPropertyIds.inventoryId = JSON.parse(resortPropertyIds.inventoryId);

    this.altDestination = resortPropertyIds;

    resortPropertyIds = resortPropertyIds.inventoryId;

    for (let index = 0; index < resortPropertyIds.length; index++) {
      const item = resortPropertyIds[index];

      this.constructInventoryItem(item);
    }
  },

  computed: {
    userID() {
      return this.$store.state.userID;
    },

    loading() {
      return this.$store.state.loading;
    },

    // location() {

    //   if (!this.$route.params.id) return;

    //   switch (this.$route.params.id) {

    //     case "phoenix":

    //       return "Phoenix, Arizona";

    //     case "breckenridge":

    //       return "Breckenridge, Colorado";

    //     case "vailbeavercreek":

    //       return "Vail/Beaver Creek, Colorado";

    //     case "avonbeavercreek":

    //       return "Avon/Beaver Creek, Colorado";

    //     case "majesticcolorado":

    //       return "Majestic Colorado";

    //     case "orlando":

    //       return "Orlando, Florida";

    //     case "branson":

    //       return "Branson, Missouri";

    //     case "parkcity":

    //       return "Park City, Utah";

    //     case "lasvegas":

    //       return "Las Vegas, Nevada";

    //     case "williamsburg":

    //       return "Williamsburg, Virginia";

    //     case "cancun":

    //       return "Cancun, Mexico";

    //     case "loscabos":

    //       return "Los Cabos, Mexico";

    //     case "puertovallarta":

    //       return "Puerto Vallarta, Mexico";

    //     case "britishcolumbia":

    //       return "British Columbia, Canada";

    //     default:

    //       return "";

    //   }

    // },

    sortOptions() {
      return (this.headers || [])

        .filter((h) => h.value && h.value !== "moreInfo")

        .map((h) => ({ text: h.text, value: h.value }));
    },
  },

  data: () => ({
    altDestination: {},

    userAccount: "",

    eventReport: "",

    specificWinner: "",

    winnerRetailPackage: "",

    items: [],

    // majesticcolorado: ["GP7", "GTR", "0005", "0867", "FAP", "TC3", "TCL"],

    // phoenix: ["5247", "8581", "D524", "D921", "DS01"],

    // breckenridge: ["GP7", "GTR"],

    // vailbeavercreek: ["0005", "0867"],

    // avonbeavercreek: ["FAP", "TC3", "TCL"],

    // orlando: [

    //   "0450",

    //   "0899",

    //   "5109",

    //   "5995",

    //   "8616",

    //   "A432",

    //   "C594",

    //   "C687",

    //   "RH55",

    //   "RYS",

    // ],

    // branson: ["1004", "3402", "4067", "4073", "3037"],

    // parkcity: ["0095", "0781", "0811", "2477", "2489"],

    // lasvegas: ["1837", "C610"],

    // williamsburg: ["3989", "5246"],

    // cancun: ["CCM", "LGU"],

    // loscabos: ["MCZ", "VDC", "VGR", "VDF", "TEC"],

    // puertovallarta: ["PRV"],

    // britishcolumbia: ["FMR", "SPE", "BIG", "FBC"],

    // sort state (tethered to table + dropdown)

    sortBy: "checkInDate",

    sortDesc: false,

    headers: [
      { text: "More Info/Book", value: "moreInfo", sortable: true },

      { text: "Destination", value: "destination", sortable: true },

      { text: "Resort Name", value: "resortName", sortable: true },

      { text: "Check In Date", value: "checkInDate", sortable: true },

      { text: "Check Out Date", value: "checkOutDate", sortable: true },

      { text: "# Nights", value: "numberOfNights", sortable: true },

      { text: "Bedrooms", value: "bedrooms", sortable: true },

      { text: "Max Occupancy", value: "maxOccupancy", sortable: true },

      { text: "Kitchen", value: "kitchen", sortable: true },

      {
        text: "Third Year Surcharge",

        value: "thirdYearSurcharge",

        sortable: true,
      },

      { text: "Total Surcharges", value: "totalSurcharges", sortable: true },
    ],
  }),

  methods: {
    async onViewAccommodation(item) {
      item.packageCode = this.specificWinner.packageCode;

      await this.$store.dispatch("setSelectedInventoryListing", item);

      this.$router.push("/inventory/" + item.resortPropertyId);
    },

    async constructInventoryItem(item) {
      // Get inventory property

      let property = firebase

        .firestore()

        .collection("inventoryProperties")

        .doc(item);

      property = await property.get();

      property = property.data();

      // Add costToOrg && bedrooms to property (filtering)

      property.costToOrg = this.winnerRetailPackage.costToOrg;

      property.retailBedrooms = this.winnerRetailPackage.bedrooms;

      // Reduce to values needed for table

      delete property.archived;

      delete property.activities;

      delete property.airportInfo;

      delete property.amenities;

      delete property.checkInInfo;

      delete property.dateSubmitted;

      delete property.dateUpdated;

      delete property.destination;

      delete property.id;

      delete property["image-src"];

      delete property.otherInfo;

      delete property.overview;

      delete property.resortAddress;

      delete property.resortName;

      delete property.resortPropertyId;

      delete property.restaurants;

      delete property.restrictions;

      delete property.source;

      delete property.template;

      delete property.unitInfo;

      // Get inventory items

      let listing = firebase

        .firestore()

        .collection("inventoryListings")

        .doc(item);

      listing = await listing.get();

      if (!listing.exists) return;

      let items = listing.data().items;

      // Add property values to listing item

      items.forEach((i) => {
        i.commissionsPaidPercentage = property.commissionsPaidPercentage;

        i.costOfExtras = property.costOfExtras;

        i.costToOrg = property.costToOrg;

        i.highOccupancySurchargeAmount = property.highOccupancySurchargeAmount;

        i.minimumProfitAccepted = property.minimumProfitAccepted;

        i.peakSeasonSurcharge1Range = property.peakSeasonSurcharge1Range; // Already strings, parsed later

        i.peakSeasonSurcharge2Range = property.peakSeasonSurcharge2Range; // Already strings, parsed later

        i.peakSeasonSurchargeAmount = property.peakSeasonSurchargeAmount;

        i.peakSeason2SurchargeAmount = property.peakSeason2SurchargeAmount;

        i.retailBedrooms = property.retailBedrooms;

        i.taxesFeesPercentage = property.taxesFeesPercentage;
      });

      const today = moment().startOf("day");

      const expiration = moment(
        this.specificWinner.travelByDate,

        "YYYY-M-D",
      ).startOf("day");

      const daysUntilExpiration = expiration.diff(today, "days");

      let earliestAllowedCheckIn;

      if (daysUntilExpiration <= 90) {
        // Package expiring soon → allow 7 days out

        earliestAllowedCheckIn = today.clone().add(7, "days");
      } else {
        // Normal alt behavior → allow 14 days out

        earliestAllowedCheckIn = today.clone().add(14, "days");
      }

      items = items.filter((i) => {
        const checkInDate = moment(i.checkInDate, "YYYY-M-D").startOf("day");

        return checkInDate.isSameOrAfter(earliestAllowedCheckIn);
      });

      // Removing any items beyond users travelByDate

      const travelByDate = moment(this.specificWinner.travelByDate, "YYYY-M-D");

      if (!travelByDate.isValid()) {
        console.error(
          `Invalid travelByDate: ${this.specificWinner.travelByDate}`,
        );

        return;
      }

      items = items.filter((i) => {
        const checkInDate = moment(i.checkInDate, "YYYY-M-D");

        if (!checkInDate.isValid()) return false;

        return checkInDate.isSameOrBefore(travelByDate);
      });

      items = items.filter((i) => i.roomCost < 501);

      // Get event date for third year surcharge calculation

      const eventDate = moment(this.eventReport.eventDate, "YYYY-M-D");

      if (!eventDate.isValid()) {
        console.error(`Invalid eventDate: ${this.eventReport.eventDate}`);

        return;
      }

      const thirdYearStart = eventDate.clone().add(2, "years");

      const thirdYearEnd = eventDate.clone().add(3, "years");

      // Format items

      items.forEach((i) => {
        // Sortable checkInDate for table sorting (optional, kept in case you need it later)

        const checkInMoment = moment(i.checkInDate, "YYYY-M-D");

        i.sortableCheckInDate = checkInMoment.isValid()
          ? checkInMoment.format("YYYYMMDD").trim()
          : "Invalid";

        // Create peakSeasonRanges for UI table display

        let peakSeasonRanges = [];

        i.peakSeasonSurcharge1Range.forEach((range) =>
          peakSeasonRanges.push(moment(range, "YYYY-M-D").format("YYYY-MM-DD")),
        );

        i.peakSeasonSurcharge2Range.forEach((range) =>
          peakSeasonRanges.push(moment(range, "YYYY-M-D").format("YYYY-MM-DD")),
        );

        i.peakSeasonRanges = peakSeasonRanges;

        // Helper to get MM-DD from date string

        const getMonthDay = (dateStr) =>
          moment(dateStr, "YYYY-M-D").format("MM-DD");

        // Extract MM-DD from peak season ranges

        const ps1Start = getMonthDay(i.peakSeasonSurcharge1Range[0]);

        const ps1End = getMonthDay(i.peakSeasonSurcharge1Range[1]);

        const ps2Start = getMonthDay(i.peakSeasonSurcharge2Range[0]);

        const ps2End = getMonthDay(i.peakSeasonSurcharge2Range[1]);

        // Function to check if target is in MM-DD range (supports year wrap-around)

        const isInRange = (start, end, target) => {
          if (!start || !end || !target) return false;

          return start <= end
            ? target >= start && target <= end
            : target >= start || target <= end;
        };

        // Calculate peakSeasonSurchargeAmount

        const checkInMD = checkInMoment.format("MM-DD");

        const originalPeakSeasonSurchargeAmount =
          i.peakSeasonSurchargeAmount || 0;

        i.peakSeasonSurchargeAmount = 0;

        const originalPeakSeason2SurchargeAmount =
          i.peakSeason2Surcharge2Amount || 0;

        i.peakSeason2SurchargeAmount = 0;

        if (checkInMoment.isValid()) {
          // Uncomment if peak season surcharge should apply
          /*

          if (isInRange(ps1Start, ps1End, checkInMD)) {

            i.peakSeasonSurchargeAmount = originalPeakSeasonSurchargeAmount;

          }

          if (isInRange(ps2Start, ps2End, checkInMD)) {

            i.peakSeason2SurchargeAmount = originalPeakSeason2SurchargeAmount || 0;

          }

          */
        }

        // High occupancy surcharge calculation (currently hardcoded to 0)

        i.highOccupancySurchargeAmount = 0;

        // Calculate Third Year Surcharge

        const checkInDate = moment(i.checkInDate, "YYYY-M-D");

        if (!checkInDate.isValid()) {
          console.warn(`Invalid checkInDate for surcharge: ${i.checkInDate}`);

          i.thirdYearSurcharge = 0;
        } else {
          i.thirdYearSurcharge = checkInDate.isBetween(
            thirdYearStart,

            thirdYearEnd,

            null,

            "[]",
          )
            ? 599
            : 0;
        }

        // Calculate total surcharges

        i.totalSurcharges =
          (i.peakSeasonSurchargeAmount || 0) +
          (i.peakSeason2SurchargeAmount || 0) +
          (i.highOccupancySurchargeAmount || 0) +
          (i.thirdYearSurcharge || 0);

        // Financial calculations

        i.totalIncome = i.costToOrg + i.totalSurcharges;

        i.commissionsPaid = (i.commissionsPaidPercentage / 100) * i.costToOrg;

        i.commissionsPaid = parseInt(i.commissionsPaid);

        i.taxesAndFees = (i.roomCost / 100) * i.taxesFeesPercentage;

        i.taxesAndFees = parseInt(i.taxesAndFees);

        i.totalCost = i.commissionsPaid + i.roomCost + i.taxesAndFees;

        i.netProfit = i.totalIncome - i.totalCost;

        // Determine display eligibility

        let wouldDisplay = false;

        if (i.netProfit >= i.minimumProfitAccepted) wouldDisplay = true;

        i.wouldDisplay = wouldDisplay;

        // Add item to items array if not archived

        if (!i.archived) this.items.push(i);
      });

      await this.$store.dispatch("setLoading", false);
    },
  },
};
</script>

<style>
/* Compact sticky notice; wraps naturally on narrow screens. */
.inventory-availability-banner {
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  margin-bottom: 12px;
  border: 1px solid #e6c35a;
  border-radius: 4px;
  background-color: #fff3cd;
  color: #493900;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: break-word;
}

@media (max-width: 600px) {
  .inventory-availability-banner {
    padding: 6px 8px;
    font-size: 10px;
    line-height: 1.3;
  }
}

tr {
  cursor: pointer;

  user-select: none !important;
}

td {
  height: 36px !important;

  width: 1px;

  white-space: nowrap;

  text-transform: capitalize;
}
</style>
